export default {
  roles: {
    roleRemoved: 'Role removed',
    roleUpdated: 'Role updated',
    roleAdded: 'Role added',
    permissionsList: 'Permissions list',
    roles: 'Roles',
    permissions: 'Permissions',
    superAdmin: 'Super Admin',
    type: {
      ADMIN: 'Admin',
      WORKER: 'Worker',
      DOCTOR: 'Doctor',
      ORG: 'Orgainzation',
      USER: 'User'
    }
  },
  permissions: {
    admin: {
      self: 'Admin',
      info: 'Info'
    },
    hooshmandteb: {
      self: 'hooshmandteb',
      device: 'device',
      'device-warning': 'device-warning'
    },
    identity: {
      self: 'identity',
      endpoints: 'endpoints',
      permissions: 'Permissions',
      realms: 'Realms',
      roles: 'Roles',
      userSessions: 'User sessions'
    },
    'user-management': {
      self: 'User management',
      'confirm-mobile-email': 'Confirm mobile and email',
      'confirm-mobile': 'Confirm mobile',
      'confirm-email': 'Confirm email',
      create: 'Create user',
      edit: 'Edit user',
      import: 'Import user',
      roles: 'User roles',
      suspend: 'Suspend user',
      users: {
        self: 'User',
        delete: 'Delete user'
      }
    },
    dashboard: {
      self: 'Dashboard',
      read: 'History/Online ECG'
    }
  }
}
